import { useEffect, useState } from 'react';
import { LandingNav } from './LandingNav';
import { LandingFooter } from './LandingFooter';
import { usePrerenderData } from '../PrerenderDataContext';
import { useI18n } from '../i18n/useI18n';

interface CmsContent {
  key: string;
  title: string;
  body: string;
  updated_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '';

export default function AboutPage() {
  const { t } = useI18n();
  const prerenderData = usePrerenderData();
  const initialContent = prerenderData.cms?.about ?? null;
  const [content, setContent] = useState<CmsContent | null>(initialContent);
  const [loading, setLoading] = useState(!initialContent);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (initialContent) return;
    let cancelled = false;
    fetch(`${API_URL}/api/cms/about`)
      .then((res) => {
        if (!res.ok) throw new Error(t('about.errorLoad'));
        return res.json();
      })
      .then((data) => {
        if (!cancelled) {
          setContent(data.content);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || t('about.contentNotFound'));
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [initialContent, t]);

  if (loading) {
    return (
      <div className="landing-page">
        <div className="landing-content">
          <LandingNav />
          <div className="page-home about-page about-page--loading">
            {t('common.loading')}
          </div>
        </div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="landing-page">
        <div className="landing-content">
          <LandingNav />
          <div className="page-home about-page about-page--error">
            {error || t('about.contentNotFound')}
          </div>
        </div>
      </div>
    );
  }

  const paragraphs = content.body
    .replace(/\r\n/g, '\n')
    .split('\n\n')
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <div className="landing-page">
      <div className="landing-content">
        <LandingNav />
        <div className="page-home about-page">
          <h1 className="about-page__title">{content.title}</h1>
          <div className="about-page__body">
            {paragraphs.map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
          </div>
        </div>
        <LandingFooter />
      </div>
    </div>
  );
}
